import { fieldNames } from "../Components/BidToolConfigurationView/constants";
import { BidConfigPayloadData } from "../types/getSettingsBidConfigDataObject";
import { regexPatterns } from "./regexUtil";

export const BidConfigPayloadFormatter = ({
  payloadData,
  id,
}: {
  payloadData: BidConfigPayloadData;
  id: string;
}) => {
  
  const truckAssupmtionsPayload = {};
  const regex = regexPatterns.baseTruckAssumptionValues;

  for (const [key, rawValue] of Object.entries(payloadData)) {
    const match = key.match(regex);
    if (!match) continue;

    const [, type, kind] = match;
    const num = Number(rawValue);
    if (!truckAssupmtionsPayload[type]) truckAssupmtionsPayload[type] = { truckType:type, biddingTons: 0, rate: 0 };

    if (kind === fieldNames.BIDDING_CONFIG_TONS) truckAssupmtionsPayload[type].biddingTons = Number(num);
    else if (kind === fieldNames.CONFIG_RATE) truckAssupmtionsPayload[type].rate = Number(num);
  }

  return {
    id: id,
    baseTruckAssumption: Object.values(truckAssupmtionsPayload),
    bidCalculationInputs: [
      {
        texasDieselAvg: Number(payloadData?.texasDieselAvgConfig),
        truckMPGAvg: Number(payloadData?.truckMPGAvgConfig),
      },
    ],
    runInformation: [
      {
        loading: Number(payloadData?.loadingTimeConfig),
      },
      {
        unloading: Number(payloadData?.unloadingTimeConfig),
      },
      {
        deadheadForwardTime: Number(payloadData?.deadheadForwardTimeConfig),
      },
      {
        deadheadForwardMile: Number(payloadData?.deadheadForwardMilesConfig),
      },
      {
        deadheadBackwardTime: Number(payloadData?.deadheadBackwardTimeConfig),
      },
      {
        deadheadBackwardMile: Number(payloadData?.deadheadBackwardMilesConfig),
      },
      {
        timeBufferSemi: Number(payloadData?.timeBufferConfig),
      },
    ],
  };
};
